<div class="top-btns">
  <div class="container">
    <div class="row btns-subcon">
      <div class="flex col-xs-6 col-sm-6 col-md-6 justify-end items-stretch">
        <button
          mat-flat-button
          class="btn-subs"
          [routerLink]="['/subscription']"
        >
          Subscribe
        </button>
      </div>
      <div class="col-xs-6 col-sm-6 col-md-6">
        <button mat-flat-button class="btn-contr" [routerLink]="['/plan']">
          Contribute
        </button>
      </div>
    </div>
  </div>
</div>
<div class="new-screen1">
  <div class="container flex flex-col">
    <div
      class="flex max-md:!flex-col max-md:!gap-[20px] md:flex-row md:gap-[20px]"
    >
      <div class="mob-view max-md:!flex-[1_1_100%] md:flex-[1_1_65%]">
        <a [href]="$safeNavigationMigration(exclusive_story?.href_link)">
          <img
            [appImgFallback]="exclusive_story?.['image_url']"
            imgContext="main"
            style="min-height: 25vh;"
            class="exclusive-mob-view"
            alt="{{ exclusive_story?.headline || '' }}"
            width="100%"
          />
          <div style="padding-top: 5px;">
            <p class="headnew">{{ exclusive_story?.headline || "" }}</p>
          </div>
        </a>

        <div class="flex flex-col" style="padding-top: 5px;">
          <div
            class="flex max-sm:!flex-row max-sm:!gap-[2px] sm:flex-row sm:gap-[10px]"
          >
            <div class="max-sm:!flex-[1_1_50%] sm:flex-[1_1_50%]">
              <a [href]="$safeNavigationMigration(exclusive_story2?.href_link)">
                <img
                  style="padding: 5px;"
                  [appImgFallback]="exclusive_story2?.['image_url']"
                  imgContext="thumb"
                  alt="{{ exclusive_story2?.headline || '' }}"
                  class="bottom-exl-image"
                  width="100%"
                />
                <div style="padding: 5px;">
                  <p class="subheadnew">
                    <span> {{ exclusive_story2?.headline || "" }} </span>
                  </p>
                </div>
              </a>
            </div>
            <div class="max-sm:!flex-[1_1_50%] sm:flex-[1_1_50%]">
              <a [href]="$safeNavigationMigration(exclusive_story3?.href_link)">
                <img
                  style="padding: 5px;"
                  [appImgFallback]="exclusive_story3?.['image_url']"
                  imgContext="thumb"
                  alt="{{ exclusive_story3?.headline || '' }}"
                  class="bottom-exl-image"
                  width="100%"
                />

                <div style="padding: 5px;">
                  <p class="subheadnew">
                    <span>{{ exclusive_story3?.headline || "" }}</span>
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="mob-view marg max-md:!flex-[1_1_100%] md:flex-[1_1_35%]">
        <h5 class="all-head">top stories</h5>
        <ul class="flex flex-col">
          @for (single_top_story of top_stories; track single_top_story; let i =
          $index) {
          <div>
            @if (i < 17) {
            <div>
              <li>
                <a href="{{ single_top_story?.href_link }}">
                  @if (single_top_story['impact_feature']) {
                  <div style="font-size: 10px; font-weight: bold">
                    Impact feature
                  </div>
                  }
                  <div class="column brdr-btm-top" style="width: 100%;">
                    <p class="internal-updates-head">
                      {{ single_top_story?.headline || "" }}
                    </p>
                  </div>
                </a>
              </li>
            </div>
            }
          </div>
          }
        </ul>
      </div>
    </div>
  </div>
</div>
